import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const toiletTrainingPants: BlogMetaData = {
  title: 'トイトレパンツの選び方｜種類別の特徴と普通のパンツへの切り替え時期',
  description:
    'トイトレパンツはいつから？何枚必要？トレーニングパンツの層タイプ・布・紙の特徴比較、普通のパンツへ切り替えるサイン、失敗した時に本人を責めない声かけまで、モンテッソーリの視点で解説します。',
  thumbnailUrl: '/img/blog-toilet-training-pants.webp',
  filePath: buildBlogFilePath('toilet-training-pants'),
  category: BLOG_CATEGORY.PARENTING,
};
